module.exports = __webpack_public_path__ + "img/SearchBar.3ff0d9cc.svg";